import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'My First Angular App! Anaflavia y Yuli';
  nuevo = '...';
}

// https://stackblitz.com/angular/xkxkdjbqaol?file=src%2Fapp%2Fhero-search%2Fhero-search.component.ts
